import "./InstructionBox.css";
import { Container, Col, Row } from "react-bootstrap";
import React from "react";

const InstructionBox = (props) => {
  return (
    <div className="mx-4 mx-md-0">
      <Container
        xl={6}
        lg={4}
        md={2}
        sm={2}
        className="instruction-box"
        style={{
          background: props.color,
          padding: "15px",
          color: "#fff",
          borderRadius: "10px",
        }}
        fluid
      >
        <Row className="d-flex align-items-center justify-content-between">
          <Col md={8} className="text-start mt-2">
            <h3 className="shared__text__first">
              Esse simulador foi criado para facilitar a sua busca pelo crédito
              imobiliário.
            </h3>
            <h2 className="shared__text__second">
              O crédito imobiliário funciona por meio da concessão de crédito de
              uma instituição financeira
            </h2>
          </Col>

          <Col
            md={4}
            className="d-flex flex-column flex-md-row justify-content-end align-items-center gap-3 mt-3 mt-md-0"
          >
            <a
              href="https://monetare.com.br/whatsapp"
              target="blank"
              className="shared-button-whatsaap"
            >
              WhatsApp
            </a>
            <a
              href="https://firebase-app-nwnvsi.flutterflow.app/login"
              target="blank"
              className="shared-button-site"
            >
              e-imob
            </a>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default InstructionBox;
